<template>
  <div class="privacy-page">
    <div class="privacy-container">
      <p class="privacy-text">
        本隐私政策(下称"隐私政策")将解释对于您在观止公司网页(包括chnvideo.com及其信息介绍的子页面，以及通过"媒体及投资者关系"页面提交的信息，下称"网页")上的个人信息之处理时间、方式及原因，并规定了您对该信息所持有的相关选择和权利。请仔细阅读——了解我们如何收集和使用您的信息，以及您可以如何控制这些信息非常重要。
      </p>
      <p class="privacy-text">
        如上文所述，本隐私政策仅适用于观止公司网页(包括chnvideo.com及其信息介绍的子页面，以及通过"媒体及投资者关系"页面提交的信息)。如您使用观止或其关联方运作的产品或服务，并欲了解相关数据如何被处理，请查阅该产品或服务的隐私政策。本隐私政策亦不适用于可能会用chnvideo.com的子域作出API调用、或可通过chnvideo.com的子域接入的任何产品或服务。
      </p>
      <p class="privacy-text">关于观止处理其供应商之信息的方式，请点击此处。</p>
      <p class="privacy-text">
        如果您不同意按照本隐私政策所述方式处理您的个人信息，请不要在收到请求时提供您的信息，并停止使用本网页。继续使用本网页即表示您确认我们在本隐私政策中所述的有关您个人信息的规定。
      </p>

      <h3 class="section-title">1. 我们使用的个人信息类型</h3>
      <p class="privacy-text">
        本节说明我们将向您收集不同类型的个人信息，以及我们如何收集这些个人信息。如果您想进一步了解特定数据类型以及我们如何使用这些数据，请参阅下面的部分"我们如何使用您的个人信息"。
      </p>
      <p class="privacy-text">以下内容总结概括了我们使用的个人信息类型：</p>
      <h4 class="sub-title">您提供给我们的信息</h4>
      <p class="privacy-text">
        在您通过使用本隐私政策中指定的联系方式联系我们时，您即向我们提供与您问询相关的特定信息。
      </p>
      <h4 class="sub-title">Cookie</h4>
      <p class="privacy-text">
        我们使用Cookie(下称"Cookie")来提升您的网页使用体验。Cookie是一种文本文件，当放置在您的设备上时，能够让我们提供特定的特性和功能。
      </p>
      <p class="privacy-text">关于我们Cookie 政策的更多信息，请单击此处。</p>
      <h4 class="sub-title">儿童</h4>
      <p class="privacy-text">
        儿童不得出于任何目的使用本网页，除非父母或监护人已提供同意。
      </p>
      <p class="privacy-text">我们所指的儿童为18周岁以下的用户。</p>
      <p class="privacy-text">
        我们不会出于任何目的故意收集儿童的个人信息。如果您认为我们在未经父母/监护人同意的情况下拥有儿童的个人信息，或者您是用户的父母或监护人并希望撤回同意，请通过chnvideo@chnvideo.com与我们联系，我们将会删除此类信息。
      </p>

      <h3 class="section-title">2. 我们如何使用您的个人信息</h3>
      <p class="privacy-text">
        本节详细说明我们向您收集的个人信息类型以及收集的原因。
      </p>
      <p class="privacy-text">
        当您向我们提交问询时，为能联系到您及处理您的问题，我们会按照法律规定，最小范围内收集您的信息并不会用于其他服务，具体信息如下：
      </p>

      <table class="info-table">
        <thead>
          <tr>
            <th>个人信息</th>
            <th>用途</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>● 您提供给我们的信息。</td>
            <td></td>
          </tr>
          <tr>
            <td>
              ● 问询表单信息：<br />
              <span class="sub-item">姓名</span><br />
              <span class="sub-item">公司名称</span><br />
              <span class="sub-item">职位名称</span><br />
              <span class="sub-item">电子邮件地址</span><br />
              <span class="sub-item">问询类别</span><br />
              <span class="sub-item">消息(问询详情)</span>
            </td>
            <td>
              我们使用这些信息来了解提交问询的人士身份以及与问询相关的内容，并联系提交问询的人士。
            </td>
          </tr>
        </tbody>
      </table>

      <h3 class="section-title">3. 我们如何存储和共享您的个人信息</h3>
      <p class="privacy-text">
        您的个人信息由我们位于中华人民共和国境内的服务器处理。我们的网页运维及技术团队位于中华人民共和国。我们将严格按照法律法规的规定，及根据本隐私政策，采取严格安全的保护措施，保护您的权利。我们使用观止云为本服务提供信息存储服务。
      </p>
      <p class="privacy-text">
        我们仅在合理必要的情况下共享您的个人信息。这类情况包括：
      </p>
      <ul class="privacy-list">
        <li>
          我们的公司为回应您的问询而处理您的个人信息。所有相关的公司只能根据本隐私政策使用您的个人信息。
        </li>
        <li>
          监管机构、司法机关和执法机构，以及出于安全、保障或遵守法律之目的的其他第三方。在一些情况下，我们依法须向当局披露您的信息，例如遵守法律义务或程序、强制实施我们的条款、处理与安全或欺诈相关的事宜，或者保护我们的用户。为遵守有效的法律程序条款，如传票、法院命令或搜查令，我们可能在获得或未获得您同意的情况下做出这些披露。一般而言，法律程序的条款禁止我们通知您任何此类披露。如果政府实体未提供所需的传票、法院命令或搜查令，则我们可能会征求您的同意，以按照政府实体的要求披露信息。我们还可能出于以下目的披露您的信息：
          <ul class="privacy-sub-list">
            <li>
              强制实施我们的条款和条件及其他协议，包括调查任何可能违反这些文件的行为；
            </li>
            <li>发现、防止或以其他方式解决安全、欺诈或技术问题；</li>
            <li>
              或在法律要求或允许的情况下，保护我们、我们的用户、第三方或公众的权利、财产或安全(为了防止欺诈和降低信用风险而与其他公司和机构交换信息)。
            </li>
          </ul>
        </li>
        <li>
          全部或部分收购我们或我们的业务的第三方。如果出现任意下述情况，我们也可能会向第三方披露您的个人信息：(a)
          我们出售、转让、合并、整合或重组业务中的任何部分，或与任何其他企业合并、收购任何其他企业或与其组建合资企业，则我们可能会将您的数据披露给任何新所有者或其他参与我们业务变更的第三方；或
          (b)
          我们出售或转让我们的任何资产，则我们持有的与您有关的信息可能会作为该等资产的一部分出售，并可能会转让给任何新所有者或其他参与该等出售或转让的第三方。
        </li>
      </ul>

      <h3 class="section-title">4. 个人信息的安全性</h3>
      <p class="privacy-text">
        无论您的个人信息存储在何处，我们均承诺维护其隐私和完整性。我们的信息安全与访问政策限制对我们的系统和技术进行访问，我们通过使用加密等技术保护措施来保护数据。
      </p>
      <p class="privacy-text">
        遗憾的是，尽管我们已实施并保持合理措施来保护您的个人信息，通过互联网传输信息并不完全安全。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。
      </p>

      <h3 class="section-title">5. 数据保留</h3>
      <p class="privacy-text">
        除非法律有所要求，否则我们保留您的数据的时间不会超过保留所需的期限。我们将按照以下方式保留您的信息：
      </p>
      <p class="privacy-text">
        您提交问询表格或使用本隐私政策中指定的详细信息联系我们时向我们提供的信息：直至您的问询得到解决，然后在解决后的一九十
        (90) 天内删除该信息，除非您同意保留这些数据并在将来接收更多信息。
      </p>
      <p class="privacy-text">
        如果需要我们在上述规定之保留期限之后保留您的信息，例如为了遵守适用法律，我们会将其与其他类型的个人信息分开存储。
      </p>

      <h3 class="section-title">6. 您的权利</h3>
      <p class="privacy-text">
        您拥有我们持有的有关您的个人信息的相关法定权利(在适用法律和法规允许范围内)。您可以请求访问或更正我们所处理的有关您的数据。
      </p>
      <p class="privacy-text">
        如要行使您的任何权利，请通过chnvideo@chnvideo.com与我们联系。
      </p>
      <p class="privacy-text">
        请注意，本网页不涉及任何个性化广告。任何电子邮件仅为回应您提交的问询而发送，并且仅为服务消息。
      </p>

      <h3 class="section-title">7. 联系和投诉</h3>
      <p class="privacy-text">
        欢迎就本隐私政策提出问题、意见和请求。我们设立了专门的个人信息保护团队和个人信息保护负责人，如果您对本隐私政策或个人信息保护相关事宜有任何疑问或投诉、建议，您可以出于遵守适用隐私法的目的，向指定的数据保护官(个人信息保护负责人)提出此类反馈，其联系方式为chnvideo@chnvideo.com。
      </p>
      <p class="privacy-text">
        如果您希望就我们处理个人信息的方式提起投诉，请首先通过
        chnvideo@chnvideo.com与我们联系，我们将努力尽快处理您的请求。
      </p>

      <h3 class="section-title">8. 变更</h3>
      <p class="privacy-text">
        如果本隐私政策有任何变更，我们将在此发布更新的隐私政策。请定期访问本页面，查看本隐私政策是否有任何更新或变更
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<style scoped>
.privacy-page {
  /* padding: 40px 0; */
  margin: 10px;
}
p {
  padding: 0;
  margin: 0;
}
.privacy-container {
  max-width: 1170px;
  margin: 0 auto;
  /* padding: 0 20px; */
  margin-top: 20px;
}

.privacy-text {
  font-size: 14px;
  color: #999;
  line-height: 1.2;
  text-align: left;
  /* margin-bottom: 10px; */
}

.privacy-list {
  list-style-type: disc;
  list-style-position: outside;
  padding-left: 2em;
  margin: 0 0 10px 0;
  border: none;
  outline: none;
}

.privacy-list li {
  font-size: 14px;
  color: #999;
  line-height: 1.8;
  margin-bottom: 6px;
  list-style-type: disc;
}

.privacy-sub-list {
  list-style-type: circle;
  list-style-position: outside;
  padding-left: 2em;
  margin: 4px 0 0 0;
}

.privacy-sub-list li {
  font-size: 14px;
  color: #999;
  line-height: 1.8;
  margin-bottom: 2px;
  list-style-type: circle;
}

.section-title {
  font-size: 16px;
  color: #000;
  font-weight: bold;
  /* margin: 20px 0 10px 0; */
  text-align: left;
}

.sub-title {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  /* margin: 20px 0 10px 0; */
  text-align: left;
}
h {
  padding: 0;
  margin: 0;
}
.indent-text {
  padding-left: 2em;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 14px;
}

.info-table th {
  background-color: #333;
  color: #fff;
  padding: 10px 12px;
  text-align: left;
  font-weight: bold;
  border: 1px solid #333;
}

.info-table td {
  padding: 10px 12px;
  border: 1px solid #ccc;
  text-align: left;
  vertical-align: top;
  line-height: 1.8;
}

.info-table tbody tr:nth-child(odd) {
  background-color: #f5f5f5;
}

.sub-item {
  padding-left: 1em;
  display: inline-block;
  line-height: 1.8;
}
</style>
